module.exports = __webpack_public_path__ + "static/media/userIcon.be39cb55.svg";